import { TypeCodeTranslation } from '../../../business/models/shared.model';

export const getTypeCodeTranslation = (tcList: TypeCodeTranslation[], languageTC: string, code: string | undefined) => {
  if (!code) { return ''; }

  const result = tcList.find((item) => item.typeCodeValue === code && item.language === languageTC);

  if (result) { return result.translation; }

  return 'Unknown type code';
};

export const getTypeCodesForLanguage = (tcList: TypeCodeTranslation[], languageTC: string) => {
  if (tcList !== undefined) {
    const result = tcList
    .filter((item) => item.language === languageTC)
    .sort((a, b) => {
      return a.sequence - b.sequence;
    });

  return result || [];
  } else {
    return [];
  }
};
